// import { Injectable } from '@angular/core';

import { StateEvent } from "../utils/inputdevice";

export enum MessageType {
  Connect = 0,
  Disconnect = 1,
  NewLayout = 2,
  NewDevice = 3,
  NewEvents = 4,
  RemoveDevice = 5,
  RemoveLayout = 6,
  ChangeUsages = 7,
  StartSending = 8,
  StopSending = 9,
}

export class Message {
  participantId: number;
  type: MessageType;
  length: number;
  data: ArrayBuffer;

  constructor(participantId: number, type: MessageType, data: ArrayBuffer) {
    this.participantId = participantId;
    this.type = type;
    this.length = data.byteLength;
    this.data = data;
  }

  get buffer(): ArrayBuffer {
    const totalSize = 12 + this.data.byteLength; // 3 * 4-byte integers + data length
    const buffer = new ArrayBuffer(totalSize);
    const dataView = new DataView(buffer);
    const uint8View = new Uint8Array(buffer);
    dataView.setUint32(0, this.participantId, true);
    dataView.setUint32(4, this.type, true);
    dataView.setUint32(8, this.length, true);
    uint8View.set(new Uint8Array(this.data), 12);
    return buffer;
  }
}

// @Injectable({
//   providedIn: 'root',
// })
export class NewDeviceMsg {
  static create(device: any): Message {
    const data = {
      name: device.name,
      layout: device.layout,
      deviceId: device.deviceId,
      variants: device.variants,
      description: device.description,
    };
    const json = JSON.stringify(data);
    const buffer = new TextEncoder().encode(json).buffer;
    return new Message(0, MessageType.NewDevice, buffer);
  }
}

// @Injectable({
//   providedIn: 'root',
// })
export class NewEventsMsg {
  static createStateEvent(device: any): Message {
    const events = StateEvent.from(device, Date.now());
    return NewEventsMsg.create(events);
  }

  static create(event: any): Message {
    return new Message(0, MessageType.NewEvents, event.buffer);
  }
}

// @Injectable({
//   providedIn: 'root',
// })
export class RemoveDeviceMsg {
  static create(device: any): Message {
    const buffer = new ArrayBuffer(4);
    const view = new DataView(buffer);
    view.setInt32(0, device.deviceId, true);
    return new Message(0, MessageType.RemoveDevice, buffer);
  }
}

// @Injectable({
//   providedIn: 'root',
// })
export class ChangeUsageMsg {
  static create(device: any): Message {
    throw new Error(`ChangeUsageMsg class is not implemented. device=${device}`);
  }
}
